import { createSelector } from 'reselect';
const getProductGroupFredhopper = (state) => state.productGroupFredhopper;
export const makeGetProductGroupFredhopper = () => createSelector(getProductGroupFredhopper, products => products);
